// extracted by mini-css-extract-plugin
export default {"caution":"caution_caution__hqN8p"};